// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bucketsStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryBuckets";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

bucketsStyles.container = {
    gap: 0,
    css: css`
        margin-bottom: 16px;
    `,
};

bucketsStyles.item = {
    width: 12,
    css: css`
        flex-wrap: wrap;
        gap: 20px;
        ${TypographyStyle} {
            font-weight: bold;
            font-size: 16px;
            line-height: 26px;
            &[data-test-selector="heading"] {
                font-size: 14px;
                line-height: 22px;
                font-weight: normal;
            }
        }

        > div {
            min-width: 180px;
            width: auto;
            ${xScreen("lte", "md")} {
                min-width: 170px;
            }
            ${xScreen("lte", "sm")} {
                min-width: 158px;
            }
            ${xScreen("lte", "xs")} {
                min-width: 130px;
            }
            &:last-child {
                min-width: 120px;
            }
        }
    `,
};
